module.exports = __webpack_public_path__ + "static/media/5-data-analytics.f219b52d.jpg";